import { combineReducers } from 'redux';

import layoutReducer from './layout/layoutReducer';
import albumPhotosFilterReducer from './albumPhotosFilter/albumPhotosFilterReducer';
import albumFolderPhotosFilterReducer from './albumFolderPhotosFilter/albumFolderPhotosFilterReducer';
import contributorUploadsReducer from './contributorUploads/contributorUploadsReducer';
import fileUploadReducer from './fileUpload/fileUploadReducer';
import multiTargetSelectionReducer from './multiTargetSelection/multiTargetSelectionReducer';
import treeviewReducer from './treeview/treeviewReducer';

const proReducer = combineReducers({
  layout: layoutReducer,
  albumPhotosFilter: albumPhotosFilterReducer,
  albumFolderPhotosFilter: albumFolderPhotosFilterReducer,
  contributorUploads: contributorUploadsReducer,
  fileUpload: fileUploadReducer,
  multiTargetSelection: multiTargetSelectionReducer,
  treeview: treeviewReducer,
});

export default proReducer;
